export const customStyles = {
  container: (provided: any): any => ({...provided, height: '20px'}),
  control: (provided: any, state: {isFocused: any}): any => ({
    ...provided,
    minHeight: '20px',
    width: '99%',
    height: '21px',
    border: 'none',
    fontSize: '16px',
    background: 'transparent',
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any) => ({
    ...provided,
    marginLeft: '1px',
    // marginTop: '12px',
    minHeight: '22px',
    top: '3px',
    height: '8px',

    borderRadius: '12px',
  }),

  input: (provided: any) => ({
    ...provided,
  }),
  indicatorSeparator: () => ({}),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    minHeight: '15px',
    height: '10px',
    marginTop: '3px',
    // height: '3px',
  }),
};
